import React, { useState, useRef, useEffect } from "react";

import MetaComponent from "../../components/common/MetaComponent";
import SidebarMenu from "../../components/dashboard/SidebarMenu";
import Header2 from "../../components/headers/Header2";

import ClipLoader from "react-spinners/ClipLoader";
import DropdownProperties from "../common/DropdownProperties.jsx";
import DropdownSelectSZType from "../common/DropdownSelectSZType.js";
import { useGetAllProperties } from "../../APIs/MasterAPIHelper.js";
import { useSnackbar } from "notistack";
import {
  Property,
  NewProperty,
  BaseURL,
  Subscription,
} from "../../APIs/APIUrls.js";
import { Link } from "react-router-dom";
import { handleKeyPress } from "../../APIs/Helper.js";
import {
  useStates,
  useCities,
  GetAllFloorPlans,
  GetAllNoofBathrooms,
  GetAllNoofBedrooms,
} from "../../APIs/MasterAPIHelper.js";
import Pagination2 from "../common/Pagination2.jsx";
import { isArray } from "chart.js/helpers";

const metadata = {
  title: "Buy Subscription || AskMeReality - Real Estate",
  description: "AskMeReality - Real Estate",
};

export default function BuySubscription() {
  const { enqueueSnackbar } = useSnackbar();
  const fetchAllProperties = useGetAllProperties();

  const vendorid = localStorage.getItem("id") || 0;

  // Safely parse token with fallback
  let Token = null;
  try {
    const tokenStr = localStorage.getItem("tcn");
    Token = tokenStr ? JSON.parse(tokenStr) : null;
  } catch (e) {
    console.error("Error parsing token:", e);
    Token = localStorage.getItem("tcn"); // Fallback to raw token if it's not JSON
  }

  //pagination and search filter states
  const [page, setPage] = useState(1);
  const [ItemsPerPage, setItemsPerPage] = useState(10);

  //My SubscriptionList useState
  const [mySubscriptions, setSubscriptions] = useState([]);
  const [mySubscriptionsFilter, setSubscriptionsFilter] = useState([]);

  //My PropertiesList useState
  const [myProperties, setMyProperties] = useState([]);

  //Form UseState
  const [VendorId, setVendorId] = useState("");
  const [AllowedPostCount, setAllowedPostCount] = useState("");
  const [SubscriptionExpiryDate, setSubscriptionExpiryDate] = useState("");
  const [IsWanttoUpgradeSubscription, setIsWanttoUpgradeSubscription] =
    useState(false);
  const [IsUpgradeSubscriptionbyAdmin, setIsUpgradeSubscriptionbyAdmin] =
    useState(false);

  const [SubscriptionStatus, setSubscriptionStatus] = useState(false);

  const AllowedPostCountRef = useRef("");

  const [lstProperties, setLstProperties] = useState([]);
  const [lstPropertiesFilter, setLstPropertiesFilter] = useState([]);
  const [PropertyId, setPropertyId] = useState("");
  const Propertyref = useRef();

  const [DocumentName, setDocumentName] = useState("");
  const DocumentNameRef = useRef();

  const [isLoading, setIsLoading] = useState(false);
  const [uploadSuccess, setUploadSuccess] = useState(false);

  useEffect(() => {
    fnGetMyProperties();
    fnGetMySubscriptions();
  }, []);

  const fnGetMyProperties = async () => {
    try {
      debugger;
      const userId = localStorage.getItem("id") || vendorid;
      if (!Token) {
        enqueueSnackbar("Authentication token not found. Please login again.", {
          variant: "error",
        });
        return;
      }

      const response = await fetch(
        NewProperty + "GetNewPropertyByVendorId/" + userId,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Token}`,
          },
          body: JSON.stringify({}),
        },
      );
      debugger;
      if (!response.ok) {
        if (response.status === 401) {
          enqueueSnackbar(
            "Unauthorized: Your session has expired. Please login again.",
            { variant: "error" },
          );
          localStorage.clear();
          window.location.href = "/";
        }
        throw new Error(`Server error: ${response.status}`);
      }

      const text = await response.text();
      if (!text || text.trim() === "") {
        throw new Error("Server returned an empty response");
      }
      const result = JSON.parse(text);
      const mydata = isArray(result.data);
      setMyProperties(mydata.length > 0 ? mydata : []);
    } catch (error) {
      console.error("Error fetching properties:", error);
      enqueueSnackbar("Error fetching properties. Please try again.", {
        variant: "error",
      });
    }
  };

  const fnGetMySubscriptions = async () => {
    try {
      const userId = localStorage.getItem("id") || vendorid;

      if (!userId) {
        enqueueSnackbar("User ID not found. Please login again.", {
          variant: "error",
        });
        return;
      }

      if (!Token) {
        enqueueSnackbar("Authentication token not found. Please login again.", {
          variant: "error",
        });
        return;
      }

      const response = await fetch(
        `${Subscription}GetSubscriptionByVendorId/${userId}`,
        {
          method: "POST", // Changed from POST to GET
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Token}`,
          },
        },
      );

      if (response.isSuccess && response.Message == "Success") {
        enqueueSnackbar("No property images found.", { variant: "info" });
        return;
      }
      const text = await response.text();
      if (!text || text.trim() === "") {
        enqueueSnackbar("No data found.", { variant: "info" });
        setSubscriptions([]);
        return;
      }

      const result = JSON.parse(text);

      // Handle different response formats
      if (result.data) {
        setSubscriptions(result.data);
        setSubscriptionsFilter(result.data);

        const activeSubscription = result.data.filter(
          (sub) =>
            sub.IsActive == true &&
            sub.IsWanttoUpgradeSubscription == true &&
            sub.IsUpgradeSubscriptionbyAdmin == true &&
            new Date(sub.SubscriptionExpiryDate) > new Date(),
        );

        setSubscriptionStatus(activeSubscription.length > 0 ? true : false);

        console.log("Fetched Subscriptions:", result.data);
      } else if (Array.isArray(result)) {
        setSubscriptions(result);
      } else {
        setSubscriptions([]);
      }
    } catch (error) {
      console.error("Error fetching property images:", error);
      enqueueSnackbar(`Error: ${error.message}`, { variant: "error" });
    }
  };

  const handleDeleteSubscriptions = async (subscriptionId) => {
    try {
      debugger;
      if (!Token) {
        enqueueSnackbar("Authentication token not found. Please login again.", {
          variant: "error",
        });
        return;
      }

      const response = await fetch(
        `${Subscription}DeleteSubscription/${subscriptionId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Token}`,
          },
          body: JSON.stringify(),
        },
      );

      if (!response.ok) {
        throw new Error(`Server error: ${response.status}`);
      }

      const result = await response.json();

      if (result.isSuccess) {
        enqueueSnackbar("Subscription deleted successfully!", {
          variant: "success",
        });

        const _mySubscriptions = mySubscriptions.filter(
          (item) => item.SubscriptionId !== subscriptionId,
        );
        setSubscriptionsFilter(_mySubscriptions);
      } else {
        enqueueSnackbar(result.Message || "Failed to delete subscription", {
          variant: "warning",
        });
      }
    } catch (error) {
      console.error("Error deleting subscription:", error);
      enqueueSnackbar("Error deleting subscription. Please try again.", {
        variant: "error",
      });
    }
  };

  const handleSubscribe = async () => {
    try {
      debugger;
      if (!Token) {
        enqueueSnackbar("Authentication token not found. Please login again.", {
          variant: "error",
        });
        return;
      }

      if (
        !AllowedPostCount ||
        isNaN(AllowedPostCount) ||
        parseInt(AllowedPostCount) <= 0
      ) {
        enqueueSnackbar("Please enter a valid number of posts.", {
          variant: "warning",
        });
        return;
      }

      setIsLoading(true);
      const userId = localStorage.getItem("id") || vendorid;
      const requestBody = {
        VendorId: userId,
        AllowedPostCount: parseInt(AllowedPostCount),
        IsWanttoUpgradeSubscription: true,
      };
      const response = await fetch(Subscription + "InsertSubscription", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Token}`,
        },
        body: JSON.stringify(requestBody),
      });
      if (!response.ok) {
        if (response.status === 401) {
          enqueueSnackbar(
            "Unauthorized: Your session has expired. Please login again.",
            { variant: "error" },
          );
          localStorage.clear();
          window.location.href = "/";
        }
        throw new Error(`Server error: ${response.status}`);
      }
      const text = await response.text();
      if (!text || text.trim() === "") {
        throw new Error("Server returned an empty response");
      }
      const result = JSON.parse(text);
      if (result.Message == "Success") {
        enqueueSnackbar("Subscription request submitted successfully!", {
          variant: "success",
        });
        setAllowedPostCount("");
        fnGetMySubscriptions();
      } else if (result.Message == "Request Already Submitted") {
        enqueueSnackbar(
          "You have already submitted a subscription request. Please wait for it to be processed.",
          { variant: "info" },
        );
      } else if (result.Message == "Subscription Already Active") {
        enqueueSnackbar(
          "You already have an active subscription. No need to submit another request.",
          { variant: "info" },
        );
      } else {
        enqueueSnackbar(
          result.Message || "Failed to submit subscription request",
          { variant: "warning" },
        );
      }
    } catch (error) {
      console.error("Error submitting subscription request:", error);
      enqueueSnackbar(
        "Error submitting subscription request. Please try again.",
        { variant: "error" },
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <MetaComponent meta={metadata} />
      <div className="layout-wrap">
        <Header2 />
        <SidebarMenu />
        <div className="main-content">
          <div className="main-content-inner">
            <div className="button-show-hide show-mb">
              <span className="body-1">Show Dashboard</span>
            </div>
            {!SubscriptionStatus && (
              <div className="box-agent-account">
                <h6>
                  Free Post Limit is 5 | After five posts, you can subscribe to
                  buy more post credits
                </h6>
                <p
                  className="note"
                  style={{
                    backgroundColor:
                      myProperties.length == 5 ? "#eb661f" : null,
                  }}
                >
                  <span style={{ fontWeight: "bolder" }}>
                    {" "}
                    {myProperties.length}
                  </span>{" "}
                  Posts uploaded.{" "}
                  {myProperties.length == 5
                    ? "Please upgrade your subscription to upload more properties."
                    : "You can upload " +
                      (5 - myProperties.length) +
                      " more propert" +
                      (5 - myProperties.length === 1 ? "y" : "ies") +
                      "."}
                </p>
              </div>
            )}

            <div className="widget-box-2 mb-20">
              <h5 className="title">Request Subscription</h5>
              {/* <div className="box grid-3 gap-30" >
                <fieldset className="box-fieldset">
                  <label htmlFor="country">
                    {" "}
                    Property:<span>*</span>{" "}
                  </label>
                  <DropdownProperties
                    options={lstProperties}
                    setItem={setPropertyId}
                    refItem={Propertyref}
                    StateValue={PropertyId}
                  />
                </fieldset>
              </div> */}
              <div className="box grid-2 gap-30">
                <fieldset className="box-fieldset">
                  <label htmlFor="country">
                    {" "}
                    Enter number of posts you want to upload in a year:
                    <span>*</span>{" "}
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter count number..."
                    value={AllowedPostCount}
                    onChange={(e) => setAllowedPostCount(e.target.value)}
                    maxLength={4}
                    onKeyDown={handleKeyPress}
                    ref={AllowedPostCountRef}
                  />
                </fieldset>
              </div>
            </div>
            <div className="box-btn">
              <button
                className="tf-btn primary"
                onClick={() => handleSubscribe()}
              >
                {isLoading && (
                  <span
                    style={{
                      marginRight: "8px",
                      display: "inline-flex",
                      alignItems: "center",
                    }}
                  >
                    <ClipLoader size={16} color="currentColor" />
                  </span>
                )}
                {isLoading
                  ? "Uploading..."
                  : uploadSuccess
                    ? "Uploaded ✓"
                    : "Subscribe"}
              </button>
            </div>
            <div
              className="widget-box-2 wd-listing"
              style={{ marginTop: "30px" }}
            >
              <h5 className="title">My Subscriptions</h5>
              <div className="wrap-table">
                <div className="box grid-3 gap-30">
                  <fieldset className="box-fieldset">
                    {/* <DropdownProperties
                      options={lstPropertiesFilter}
                      setItem={setPropertyIdFilter}
                      refItem={PropertyFilterref}
                      StateValue={PropertyIdFilter}
                    /> */}
                  </fieldset>
                </div>
                <div className="table-responsive">
                  <table>
                    <thead>
                      <tr>
                        <th style={{ width: "8%" }}>Sr No</th>
                        <th>Subscribed Count </th>
                        <th> Requested Date</th>
                        <th> Expiry Date</th>
                        <th style={{ width: "5%" }}>Status</th>
                        {/* <th>Action</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {mySubscriptionsFilter
                        .slice((page - 1) * ItemsPerPage, page * ItemsPerPage)
                        .map((docItem, index) => (
                          <tr className="file-delete" key={index}>
                            <td style={{ width: "8%" }}>
                              <span style={{ marginLeft: "20px" }}>
                                {(page - 1) * ItemsPerPage + index + 1}
                              </span>
                            </td>
                            <td>
                              <div className="listing-box">
                                <div className="content">
                                  <div className="title">
                                    <ul className="list-action">
                                      <li>
                                        <Link className="link">
                                          <strong>
                                            <span
                                              style={{
                                                color: "black",
                                                fontWeight: "bolder",
                                              }}
                                            >
                                              {" "}
                                              {docItem.AllowedPostCount}
                                            </span>{" "}
                                          </strong>
                                        </Link>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td>
                              <div className="listing-box">
                                <div className="content">
                                  <div className="title">
                                    <ul className="list-action">
                                      <li>
                                        {" "}
                                        <Link className="link">
                                          <strong>
                                            {" "}
                                            <span
                                              style={{
                                                color: "black",
                                                fontWeight: "bolder",
                                              }}
                                            >
                                              {new Date(docItem.CreatedOn)
                                                .toLocaleDateString("en-GB", {
                                                  day: "2-digit",
                                                  month: "short",
                                                  year: "numeric",
                                                })
                                                .replace(/ /g, "-")}
                                            </span>
                                          </strong>
                                        </Link>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td>
                              <div className="listing-box">
                                <div className="content">
                                  <div className="title">
                                    <ul className="list-action">
                                      <li>
                                        {docItem.IsActive &&
                                          docItem.IsWanttoUpgradeSubscription &&
                                          docItem.IsUpgradeSubscriptionbyAdmin && (
                                            <Link className="link">
                                              <strong>
                                                {" "}
                                                <span
                                                  style={{
                                                    color: "black",
                                                    fontWeight: "bolder",
                                                  }}
                                                >
                                                  {new Date(
                                                    docItem.SubscriptionExpiryDate,
                                                  )
                                                    .toLocaleDateString(
                                                      "en-GB",
                                                      {
                                                        day: "2-digit",
                                                        month: "short",
                                                        year: "numeric",
                                                      },
                                                    )
                                                    .replace(/ /g, "-")}
                                                </span>
                                              </strong>
                                            </Link>
                                          )}
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td>
                              <ul className="list-action">
                                <li>
                                  <div
                                    className="widget-box-2"
                                    style={{ padding: "0px" }}
                                  >
                                    <div className="box-info-property">
                                      <fieldset
                                        className="box box-fieldset"
                                        style={{ marginBottom: "10px" }}
                                      >
                                        <label htmlFor="title">
                                          {docItem.IsWanttoUpgradeSubscription &&
                                          !docItem.IsUpgradeSubscriptionbyAdmin ? (
                                            <span
                                              className="btn btn-sm btn-warning"
                                              disabled
                                            >
                                              Pending
                                            </span>
                                          ) : docItem.IsWanttoUpgradeSubscription &&
                                            docItem.IsUpgradeSubscriptionbyAdmin &&
                                            docItem.IsActive &&
                                            new Date(
                                              docItem.SubscriptionExpiryDate,
                                            ) > new Date() ? (
                                            <span className="btn btn-sm btn-success">
                                              Active
                                            </span>
                                          ) : !docItem.IsWanttoUpgradeSubscription &&
                                            !docItem.IsUpgradeSubscriptionbyAdmin &&
                                            !docItem.IsActive ? (
                                            <span className="btn btn-sm btn-danger">
                                              Rejected
                                            </span>
                                          ) : docItem.IsWanttoUpgradeSubscription &&
                                            docItem.IsUpgradeSubscriptionbyAdmin &&
                                            docItem.IsActive &&
                                            new Date(
                                              docItem.SubscriptionExpiryDate,
                                            ) < new Date() ? (
                                            <span className="btn btn-sm btn-danger">
                                              Expired
                                            </span>
                                          ) : null}
                                        </label>
                                      </fieldset>
                                    </div>
                                  </div>
                                </li>
                              </ul>
                            </td>
                            {/* <td>
                              <ul className="list-action">
                                <li>
                                  <a className=" btn btn-danger" onClick={() => {
                                    if (window.confirm("Are you sure you want to delete this subscription?")) {
                                      handleDeleteSubscriptions(docItem.SubscriptionId);
                                    }
                                  }}  >
                                    Delete
                                  </a>
                                </li>
                              </ul>
                            </td> */}
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
                <ul className="wd-navigation">
                  <Pagination2
                    itemLength={mySubscriptionsFilter.length}
                    itemPerPage={ItemsPerPage}
                    setPage={setPage}
                  />
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="overlay-dashboard" />
      </div>
    </>
  );
}
